module.exports = __webpack_public_path__ + "static/features_mobile-b420ea4cae3c816ee343a3055551059f.jpg";